import styled from "styled-components";
import {
  orangeColor,
  questionDarkTextColor,
  questionTextColor,
  checkBoxPointColor,
  greyColor,
  greenColor,
  whiteColor,
  darkColor,
  blackColor,
  lightSecondColor,
  greyTextColor,
} from "../../../constants/colors";

const CheckboxBlock = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  margin-bottom: 14px;
  padding: 15px;
  border-radius: 80px;
  background: ${(props) =>
    props.isActive !== undefined ? greenColor : greyColor};
  transition: 0.3s;
  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgb(0 0 0 / 10%);
  }
  &.main {
    border: 2px solid rgba(236, 235, 255, 0.1);
    background: ${(props) =>
      props.isActive !== undefined
        ? lightSecondColor
        : "rgba(53, 48, 120, 0.5)"};
  }
`;

CheckboxBlock.Point = styled.div`
  width: 22px;
  height: 22px;
  margin-right: 12px;
`;

CheckboxBlock.Point.Round = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 1px solid ${checkBoxPointColor};
  background: ${(props) =>
    props.isActive !== undefined ? whiteColor : greyColor};
  display: flex;
  justify-content: center;
  align-items: center;
  &.main {
    border: ${(props) =>
      props.isActive !== undefined
        ? orangeColor
        : "2px solid rgba(236, 235, 255, 0.7)"};
    background: ${(props) =>
      props.isActive !== undefined ? orangeColor : "inherit"};
  }
`;

CheckboxBlock.Text = styled.div`
  flex-grow: 1;
  justify-content: center;
  transform: translateX(-20px);
  p {
    color: ${(props) =>
      props.isActive !== undefined ? whiteColor : darkColor};
    &.main {
      color: ${(props) =>
        props.isActive !== undefined ? blackColor : greyTextColor};
    }
  }
`;

export { CheckboxBlock };
